import _mixin from '../_mixin'

export default {
  name: 'SActLottery',
  cnName: '活动-抽奖',
  type: 'activity_five',
  draggable: false,
  needLogin: true,
  preview: 'https://rescdn.ssjj.cn/website/2024/01/31/e5e5b15425bf8b0875b46d4b1b655838.jpg',
  // 属性相关
  props: {
    activityId1: 'D7OTNBTWJNDA5XG5HRPONRZYUI',
    activityId2: 'GF6SKSQMKCL6FTWX7DLJGZZCFY',
    // 主图
    mainImg: '',
    // 整条进度色
    allProgressColor: '#D9C4FF',
    // 整条进度的高
    allProgressHeight: '5px',
    // 奖励进度色
    awardProgressColor: '#a485df',
    // 奖励进度的高
    awardProgressHeight: '5px',
    // 进度数量圆圈色
    circleProgressColor: '#D9C4FF',
    // 进度数量值颜色
    circleProgressValueColor: '#ffffff',
    // 奖励名称
    textColor: '#ffffff',
    // 当前进度值
    currentPoint: '_ 150px 100px _',

    btnSize: '260px 80px',
    // 抽取按钮
    btnLotteryOne: {
      src: 'https://rescdn.ssjj.cn/website/2024/02/01/67b89552ab28e1234f938e8213e365ac.png',
      style: {
        top: '',
        left: '',
        right: '100px',
        bottom: '250px'
      }
    },
    btnLotteryTen: {
      src: 'https://rescdn.ssjj.cn/website/2024/01/29/152426d1a883235da066b967de04c616.png',
      style: {
        top: '',
        left: '',
        right: '100px',
        bottom: '150px'
      }
    }
  },
  propsDesc: [
    {
      target: '活动ID配置',
      formType: 'divider'
    },
    {
      target: 'activityId1',
      label: '抽奖ID'
    },
    {
      target: 'activityId2',
      label: '进度领取奖励ID'
    },
    {
      target: 'mainImg',
      label: '主图'
    },
    {
      target: 'allProgressColor',
      label: '整条进度色',
      formType: 'color'
    },
    {
      target: 'allProgressHeight',
      label: '整条进度的高'
    },
    {
      target: 'awardProgressColor',
      label: '奖励进度色',
      formType: 'color'
    },
    {
      target: 'awardProgressHeight',
      label: '奖励进度的高'
    },
    {
      target: 'circleProgressColor',
      label: '圆圈进度色',
      formType: 'color'
    },
    {
      target: 'circleProgressValueColor',
      label: '圆圈进度值',
      formType: 'color'
    },
    {
      target: 'textColor',
      label: '奖励名颜色',
      formType: 'color'
    },
    {
      target: 'currentPoint',
      label: '当前进度值',
      formType: 'position'
    },
    {
      target: '抽奖按钮',
      formType: 'divider'
    },
    {
      target: 'btnSize',
      label: '按钮大小'
    },
    {
      target: 'btnLotteryOne',
      label: '抽奖一次按钮',
      formType: 'image'
    },
    {
      target: 'btnLotteryTen',
      label: '抽奖十次按钮',
      formType: 'image'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles,
    position: 'relative',
    color: '#fff'
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
